/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSpecialPlaceCommand
 */
export interface UpdateSpecialPlaceCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateSpecialPlaceCommand
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpecialPlaceCommand
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpecialPlaceCommand
     */
    description?: string | null;
}

export function UpdateSpecialPlaceCommandFromJSON(json: any): UpdateSpecialPlaceCommand {
    return UpdateSpecialPlaceCommandFromJSONTyped(json, false);
}

export function UpdateSpecialPlaceCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSpecialPlaceCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function UpdateSpecialPlaceCommandToJSON(value?: UpdateSpecialPlaceCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
    };
}


